import {
  FullWidthTextComponent,
  FullWidthTextComponentTile,
} from '@varo/graphql-schema-types';
import VXLTextBorrowingPowerCompatibility from 'features/borrowingPower/BorrowingPowerScreen/components/VXLTextBorrowingPowerCompatibility';
import React from 'react';
import { VXLNode } from 'shared/renderer/types';

const fullWidthTextComponent = (
  component: FullWidthTextComponent | FullWidthTextComponentTile,
): VXLNode => {
  return {
    id: component.id,
    render: () => <VXLTextBorrowingPowerCompatibility {...component} />,
  };
};

export default fullWidthTextComponent;
